import { AxiosPromise } from 'axios';
import { FileItemInfo } from '../../types/FileItemInfo';
import { libApiInstance } from '../axios';

export function requestAllFiles(signal?: AbortSignal): AxiosPromise<FileItemInfo[]> {
    return libApiInstance.get(`/myfiles`, { signal });
}

export function requestUploadFile(
    file: FormData,
    signal?: AbortSignal,
): AxiosPromise<FileItemInfo[]> {
    return libApiInstance.post(`/myfiles`, file, {
        signal,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    });
}
